module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-light-300.ttf";